var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70743 3.29325C5.09843 3.68425 5.09843 4.31631 4.70743 4.70731L1.70743 7.70731C1.51243 7.90231 1.25646 8.00028 1.00046 8.00028C0.744465 8.00028 0.488494 7.90231 0.293494 7.70731C-0.0975058 7.31631 -0.0975058 6.68425 0.293494 6.29325L2.58646 4.00028L0.293494 1.70731C-0.0975058 1.31631 -0.0975058 0.68425 0.293494 0.29325C0.684494 -0.0977499 1.31643 -0.0977499 1.70743 0.29325L4.70743 3.29325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7077 3.29325C11.0987 3.68425 11.0987 4.31631 10.7077 4.70731L7.70768 7.70731C7.51268 7.90231 7.25671 8.00028 7.00071 8.00028C6.74471 8.00028 6.48874 7.90231 6.29374 7.70731C5.90274 7.31631 5.90274 6.68425 6.29374 6.29325L8.58671 4.00028L6.29374 1.70731C5.90274 1.31631 5.90274 0.68425 6.29374 0.29325C6.68474 -0.0977499 7.31668 -0.0977499 7.70768 0.29325L10.7077 3.29325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.3516f905f4f5db0490ce7ccba4369207.svg";
export { ForwardRef as ReactComponent };